import axios from "axios";
import type { DigitalAssetAppleAppName } from "../types";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export const getDigitalAssetAppleAppNames = async () => {
  const { data } = await axios.get<DigitalAssetAppleAppName[]>(
    `${API_BASE_URL}/GetDigitalAssetAppleAppNames`,
  );

  return data;
};